import React from 'react';
import styles from '../../styles/Dashboard/FavoriteCard.module.css';

const FavoriteCard = ({ unit, userColors, onRemove, onClick }) => {
  const likedBy = unit.likedBy || ['You'];

  return (
    <div className={styles.card} onClick={onClick}>
      <img src={unit.ImageURL} alt={unit.Address} className={styles.cardImage} />
      <div className={styles.removeButton} onClick={onRemove}>✕</div>
      <div className={styles.cardContent}>
        <div className={styles.cardAddress}>{unit.Address}</div>
        <div className={styles.cardCity}>{unit.City}, {unit.State}</div>

        <div className={styles.cardLikedBy}>
          {likedBy.map(user => (
            <div
              key={user}
              className={styles.avatar}
              style={{ backgroundColor: userColors[user] }}
            >
              {user[0]}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FavoriteCard;
